export const pageLinks = [
  { href: '/', label: 'Home' },
  { href: '/about', label: 'About' },
  { href: '/data_sources', label: 'Data Sources' },
  { href: '/wiki', label: 'Wiki' },
  { href: '/disclaimer', label: 'Disclaimer' },
  { href: '/download-portal', label: 'Download Portal' },
  { href: '/comparison-portal', label: 'Comparison Portal' },
];
